module.exports = __webpack_public_path__ + "img/SBlogo.9a88f15d.png";